import React from 'react';
import './MaintenanceBanner.css';

/**
 * Juoda juostelė viršuje su tekstu "Atnaujinimo režimas".
 * Rodo administratoriui, kad parduotuvė yra offline režime.
 * Spaceris išstumia turinį žemyn, kad juosta neužliestų headerio.
 */
function MaintenanceBanner() {
  return (
    <>
      <div className="maintenance-banner" role="status" aria-live="polite">
        Atnaujinimo režimas
      </div>
      <div className="maintenance-banner-spacer" aria-hidden="true" />
    </>
  );
}

export default MaintenanceBanner;
